export const selectAuthUser = (state) => state?.user?.auth?.user;

export const selectActiveWebProfileId = (state) => {
    const profiles = state?.user?.auth?.user?.profiles ?? [];
    const active = profiles.find((p) => p?.activeInWeb);
    return active?.id ?? null;
};

export const selectUnreadCount = (state) => state?.notifications?.unreadCount ?? 0;
export const selectTopUnread = (state) => state?.notifications?.topUnread ?? [];
